import { TableCell } from '@mui/material';
import { formatBalanceUi, FRACTION_DIGITS } from '@utils/balance-helpers';

export default function CardLimitCell({ row }) {
  return (
    <TableCell>
      <div className="t-right">
        <p>
          {formatBalanceUi(row.limit, row.currency, FRACTION_DIGITS.INTEGER)}
        </p>
        <p className="secondary-text">
          {formatBalanceUi(
            row.transaction_limit,
            row.currency,
            FRACTION_DIGITS.INTEGER,
          )}
        </p>
      </div>
    </TableCell>
  );
}
